import React from 'react';
import {
  Box,
  Flex,
  ShowInLargeUp,
  ShowInMediumDown,
} from '@components/layout/Grid';
import BaseSkeleton from '@skeletons/BaseSkeleton';

const VideosGenresVideosSkeleton = ({ numberOfCards = 6 }) => (
  <React.Fragment>
    <Box as={ShowInMediumDown} pt={20}>
      <Flex mb="20px" justifyContent="space-between" alignItems="center">
        <BaseSkeleton shape="square" height={20} width={35} />
        <BaseSkeleton shape="square" height={20} width={35} />
      </Flex>
    </Box>
    <Box as={ShowInLargeUp} pt={20}>
      <Flex mb="20px" justifyContent="space-between" alignItems="center">
        <BaseSkeleton shape="square" height={20} width={10} />
        <BaseSkeleton shape="square" height={20} width={15} />
      </Flex>
    </Box>

    <div className="grid grid-col-1 md:grid-cols-3 gap-4 md:gap-5 py-5">
      {[...Array(numberOfCards).keys()].map((_, i) => (
        <div
          key={i}
          className="border border-neutral-200 rounded animate-pulse"
        >
          <div className="flex aspect-video bg-neutral-200"></div>
          <div className="flex flex-col gap-3 p-5">
            <div className="h-4 w-4/5 bg-neutral-200"></div>
            <div className="h-4 w-3/5 bg-neutral-200"></div>
            <div className="h-10 bg-neutral-200"></div>
          </div>
        </div>
      ))}
    </div>
  </React.Fragment>
);

export default VideosGenresVideosSkeleton;
